import dayjs from 'dayjs';
import weekOfYear from 'dayjs/plugin/weekOfYear';
dayjs.extend(weekOfYear);

/**
 * 해당 날짜의 주차를 반환
 *
 * ex) "2024-06-06" -> 2
 * @param date
 * @returns
 */
export default function getWeekNumber(date: Date | string | dayjs.Dayjs) {
  const weekNum = dayjs(date).week();
  const firstDayWeekNum = dayjs(date).date(1).week();

  return weekNum - firstDayWeekNum + 1;
}
